import { render } from "./DbsMyUsing.vue?vue&type=template&id=69480bcf"
import script from "./DbsMyUsing.vue?vue&type=script&lang=js"
export * from "./DbsMyUsing.vue?vue&type=script&lang=js"
script.render = render

export default script